// extracted by mini-css-extract-plugin
export default {"tile-badge":"youroffers--2CxL6","tile-badge__label":"youroffers--2978Y","tile-badge__label--super-offer":"youroffers--2dfDV"};